/* eslint-disable max-len */
import React from 'react';

const InstallTariffs: React.FC<object> = () => {

    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_6575_138737)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 0C10.6569 0 12 1.34315 12 3V9C12 10.6569 10.6569 12 9 12H3C1.34315 12 0 10.6569 0 9V3C0 1.34315 1.34315 0 3 0H9ZM4 7.5C3.72386 7.5 3.5 7.72386 3.5 8V9.5C3.5 9.77614 3.72386 10 4 10C4.27614 10 4.5 9.77614 4.5 9.5V8C4.5 7.72386 4.27614 7.5 4 7.5ZM8 4.5C7.72386 4.5 7.5 4.72386 7.5 5V9.5C7.5 9.77614 7.72386 10 8 10C8.27614 10 8.5 9.77614 8.5 9.5V5C8.5 4.72386 8.27614 4.5 8 4.5ZM3.5 5C2.94772 5 2.5 5.44772 2.5 6C2.5 6.55228 2.94772 7 3.5 7H4.5C5.05228 7 5.5 6.55228 5.5 6C5.5 5.44772 5.05228 5 4.5 5H3.5ZM4 2C3.72386 2 3.5 2.22386 3.5 2.5V4C3.5 4.27614 3.72386 4.5 4 4.5C4.27614 4.5 4.5 4.27614 4.5 4V2.5C4.5 2.22386 4.27614 2 4 2ZM7.5 2C6.94772 2 6.5 2.44772 6.5 3C6.5 3.55228 6.94772 4 7.5 4H8.5C9.05228 4 9.5 3.55228 9.5 3C9.5 2.44772 9.05228 2 8.5 2H7.5Z"
                    fill="#616E6E"
                />
            </g>
            <defs>
                <clipPath id="clip0_6575_138737">
                    <rect
                        width="12"
                        height="12"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default InstallTariffs;